import { formatLeadFormFields } from "./formatLeadFormFields";

export function formatLeadMarkdown(payload) {
  const fields = formatLeadFormFields(payload);
  const { _subject, _replyto, ...rest } = fields;
  const lines = Object.entries(rest).map(([key, value]) => `**${key}：** ${value}`);

  return {
    title: _subject || "官网新询盘",
    content: lines.join("\n\n"),
    replyTo: _replyto,
  };
}
